import * as React from "react";
function SvgHamburger(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 7.25H3v-2.5h18v2.5zm0 6H3v-2.5h18v2.5zm-18 6h18v-2.5H3v2.5z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgHamburger);
export default ForwardRef;
